export default __webpack_public_path__ + "static/media/donut.9bda1e1d.svg";